/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ kg: NonNullable<unknown>, time: NonNullable<unknown>, name: NonNullable<unknown> }} Tea_Purchase_Processed_At_ByInputs */

const vi_tea_purchase_processed_at_by = /** @type {(inputs: Tea_Purchase_Processed_At_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Khối lượng khô: ${i?.kg} kg • ${i?.time} bởi ${i?.name}`)
};

/**

* @param {Tea_Purchase_Processed_At_ByInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_processed_at_by = /** @type {((inputs: Tea_Purchase_Processed_At_ByInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Processed_At_ByInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_processed_at_by(inputs)
});